export default __webpack_public_path__ + "static/media/cheque-layout-2x.93d7f586.png";